import {Injectable} from '@angular/core';
import * as XLSX from 'xlsx';
import {DatePipe} from '@angular/common';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

    constructor(private datepipe: DatePipe) {
    }

    public exportAsExcelFile(json: object[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = {Sheets: {data: worksheet}, SheetNames: ['data']};
        const excelBuffer: ArrayBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    private saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
        const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
        const downloadUrl = URL.createObjectURL(data);
        const downloadLink = document.createElement('a');

        downloadLink.href = downloadUrl;
        downloadLink.download = fileName + '_export_'
            + this.datepipe.transform(new Date(), 'dd-MM-yyyy') + EXCEL_EXTENSION;
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        setTimeout(() => URL.revokeObjectURL(downloadUrl), 0);
    }
}
